module.exports = __webpack_public_path__ + "img/KSC08155.6ef35131.jpg";